"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TextCaption = void 0;
var _createText = require("./createText");
const TextCaption = (0, _createText.createText)('caption');
exports.TextCaption = TextCaption;